import storage from 'store'
import expirePlugin from 'store/plugins/expire'

storage.addPlugin(expirePlugin)
const tabs = {
    state: {
        currentTab: undefined,
        tabs: [
            {
                name: '工作台',
                code: 'WorkHomeIndex',
                key: 'WorkHomeIndex'
            }
        ],
        iframeList: [],
        navigationIframeList: [],
        programIframeList: []
    },

    mutations: {
        SET_CURRENT_TAB: (state, tab) => {
            state.currentTab = tab
        },
        SET_TABS: (state, tabs) => {
            state.tabs = tabs
        },
        SET_IFRAME_LIST: (state, iframeList) => {
            state.iframeList = iframeList
        },
        SET_NAVIGATION_IFRAME_LIST: (state, navigationIframeList) => {
            state.navigationIframeList = navigationIframeList
        },
        SET_PROGRAM_IFRAME_LIST: (state, programIframeList) => {
            state.programIframeList = programIframeList
        }
    },

    actions: {

        // 添加标签页
        AddTab({commit, state}, currentTab) {
            return new Promise((resolve) => {
                if (!currentTab.key) {
                    currentTab.key = currentTab.code;
                }
                if (currentTab.code !== 'WorkHomeIndex') {
                    const currentTabs = state.tabs.filter(tab => currentTab.key === tab.key)
                    if (currentTabs.length > 0) {
                        commit('SET_CURRENT_TAB', currentTabs[0])
                    } else {
                        commit('SET_CURRENT_TAB', currentTab)
                        commit('SET_TABS', [...state.tabs, currentTab])
                    }

                }
                if (currentTab.url) {
                    const currentIframes = state.iframeList.filter(iframe => currentTab.key === iframe.key)
                    if (currentIframes.length === 0) {
                        commit('SET_IFRAME_LIST', [...state.iframeList, currentTab])
                    }
                }

                resolve()
            })
        },

        // 添加iframe
        AddNavigationIframe({commit, state}, currentTab) {
            return new Promise((resolve) => {
                const currentIframes = state.navigationIframeList.filter(iframe => currentTab.code === iframe.code)
                if (currentIframes.length === 0) {
                    commit('SET_NAVIGATION_IFRAME_LIST', [...state.navigationIframeList, currentTab])
                }
                resolve()
            })
        },

        // 添加小程序预览
        AddProgramIframe({commit, state}, currentTab) {
            return new Promise((resolve) => {
                const currentIframes = state.programIframeList.filter(iframe => currentTab.code === iframe.code)
                if (currentIframes.length === 0) {
                    commit('SET_PROGRAM_IFRAME_LIST', [...state.programIframeList, currentTab])
                }
                resolve()
            })
        },

        // 删除小程序预览
        RemoveProgramIframe({commit, state}, currentTab) {
            return new Promise((resolve) => {
                const currentIframes = state.programIframeList.filter(iframe => currentTab !== iframe.id)
                commit('SET_PROGRAM_IFRAME_LIST', currentIframes)
                resolve()
            })
        },

        ActiveTab({commit, state}, currentTab) {
            return new Promise((resolve) => {
                const currentTabs = state.tabs.filter(tab => currentTab === tab.key)
                if (currentTabs.length > 0) {
                    commit('SET_CURRENT_TAB', currentTabs[0])
                }
                resolve()
            })
        },

        DeleteTab({commit, state}, currentTab) {
            return new Promise((resolve) => {
                const notCurrentTabs = state.tabs.filter(tab => currentTab !== tab.key)
                const currentIframeList = state.iframeList.filter(iframe => currentTab !== iframe.key)
                commit('SET_TABS', notCurrentTabs)
                if (notCurrentTabs.length === 1) {
                    commit('SET_CURRENT_TAB', notCurrentTabs[0])
                }
                commit('SET_IFRAME_LIST', currentIframeList)
                resolve()
            })
        }

    }
}

export default tabs
